import pubsub from "pubsub-js";
import events from "./events";

export { events };
export const subscribe = (topic, handler) => pubsub.subscribe(topic, handler);
export const publish = (topic, data) => pubsub.publish(topic, data);
export const unsubscribe = (token) => {
  pubsub.unsubscribe(token);
};
